import { render, staticRenderFns } from "./UploadMaterialDialog.vue?vue&type=template&id=080ec151"
import script from "./UploadMaterialDialog.vue?vue&type=script&lang=ts"
export * from "./UploadMaterialDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports